import Image from 'next/image'
import HomepageBookCallButton from './HomepageBookCallButton'

function HeroStat({ value, label }) {
    return (
        <div>
            <div className="text-[26px] font-extrabold leading-none tracking-[-0.02em] text-[#3F454F]">
                {value}
            </div>
            <div className="mt-[5px] text-xs font-medium text-[#6F7785]">
                {label}
            </div>
        </div>
    )
}

function HeroVisual() {
    return (
        <div className="relative flex min-h-[300px] items-center justify-center sm:min-h-[420px] lg:min-h-[520px]">
            <div className="relative w-full max-w-[300px] min-[380px]:max-w-[340px] sm:max-w-[460px] lg:max-w-[490px]">
                <Image
                    src="/assets/homepage/HeroImageV2.png"
                    alt="Direct mail campaign examples with response notifications"
                    width={1124}
                    height={992}
                    priority
                    className="h-auto w-full object-contain"
                />
            </div>
        </div>
    )
}

function HomepageHero() {
    return (
        <section className="relative overflow-hidden border-b border-black/10 bg-[linear-gradient(170deg,#FFF9F2_0%,#FFFCF7_70%)]">
            <div className="pointer-events-none absolute right-[-180px] top-[-240px] h-[600px] w-[600px] rounded-full bg-[radial-gradient(circle,rgba(250,179,49,0.18)_0%,transparent_65%)]" />
            <div className="pointer-events-none absolute bottom-[-160px] left-[-120px] h-[440px] w-[440px] rounded-full bg-[radial-gradient(circle,rgba(237,92,47,0.10)_0%,transparent_65%)]" />
            <div className="container mx-auto grid gap-12 px-5 py-[56px] md:px-0 lg:grid-cols-2 lg:gap-14 lg:py-[76px] xl:pb-[88px]">
                <div className="homepage-v2-hero-stagger flex flex-col">
                    <div className="mb-6 inline-flex w-fit items-center gap-2 rounded-full border border-[rgba(237,92,47,0.2)] bg-white px-4 py-[7px] text-xs font-bold uppercase tracking-[0.04em] text-[#ED5C2F] shadow-[0_2px_8px_-2px_rgba(237,92,47,0.15)]">
                        <span className="homepage-v2-pulse-dot h-1.5 w-1.5 rounded-full bg-[#ED5C2F]" />
                        <span>Mailhouse + Strategy + Software</span>
                    </div>

                    <h1 className="mb-[22px] text-[clamp(38px,4.8vw,58px)] font-extrabold leading-[1.05] tracking-[-0.025em] text-[#3F454F]">
                        <span className="block">Better direct mail</span>
                        <span className="block olm-gradient-text">
                            starts here.
                        </span>
                    </h1>

                    <p className="mb-8 max-w-[500px] text-[18px] leading-[1.65] text-[#4A5160]">
                        Strategy, mailing lists, print production, campaign
                        execution, and software integrations for businesses
                        ready to launch, improve, or scale direct mail.
                    </p>

                    <div className="flex flex-wrap items-center gap-3">
                        <HomepageBookCallButton>
                            Book a Strategy Call
                        </HomepageBookCallButton>
                    </div>

                    <div className="mt-11 flex flex-wrap gap-9 border-t border-black/10 pt-8">
                        <HeroStat value="100M+" label="Pieces mailed" />
                        <HeroStat value="5,000+" label="Trusted customers" />
                        <HeroStat value="2-day" label="Production available" />
                        <HeroStat value="★ 5.0" label="Customer rating" />
                    </div>
                </div>

                <div className="homepage-v2-fade-up">
                    <HeroVisual />
                </div>
            </div>
        </section>
    )
}

export default HomepageHero
